import React, { type FunctionComponent } from 'react'
import { css } from '@emotion/react'
import { colors } from '@retailer-platform/shared-components'
import { useIntl } from 'react-intl'
import styled from '@emotion/styled'
import DevPortalLogo from 'assets/dev-portal-logo.svg'
import { TextContainer } from 'gin-and-tonic/containers/nav/components/NavItem'
import { NavSeparator } from 'gin-and-tonic/containers/nav/components/NavSeparator'
import { NavIconWrapper } from 'gin-and-tonic/containers/nav/components/NavIconWrapper'

const logoStyle = css({
  width: '36px',
})

const HeaderWrapper = styled.div({
  width: '256px',
  display: 'flex',
})

export const DevPortalNavHeaderContent: FunctionComponent = () => {
  const intl = useIntl()
  return (
    <React.Fragment>
      <HeaderWrapper>
        <NavIconWrapper>
          <img src={DevPortalLogo} css={logoStyle} />
        </NavIconWrapper>
        <TextContainer data-testid="nav-item-text" isMainItem={true}>
          {intl.formatMessage({ id: 'app.devPortal.nav.header' })}
        </TextContainer>
      </HeaderWrapper>
      <NavSeparator backgroundColor={colors.GRAYSCALE.X20} />
    </React.Fragment>
  )
}
